import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-[#4e6354] text-white pt-16 pb-8 relative overflow-hidden">
      {/* Watermark Overlay - Winding Road */}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-[0.08] flex items-start justify-center">
        <img 
          src="https://assets.auxodev.dk/assets/eff3456d-e9a8-4cc4-936d-27bf51e95b8f/95574613-b9ad-4e75-84fb-52de2d444fa1.png" 
          alt="" 
          className="w-full h-full object-cover scale-150 rotate-6 invert brightness-200 object-top"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <img 
              src="https://assets.auxodev.dk/assets/eff3456d-e9a8-4cc4-936d-27bf51e95b8f/953decc8-861e-4742-a986-d0e92d8fe243.png" 
              alt="Anette Lundager Schädler Logo" 
              className="h-32 mb-6 w-auto"
            />
            <h3 className="text-lg font-light mb-6 uppercase">Anette Lundager Schädler</h3>
            <p className="text-stone-200 leading-relaxed mb-6">
              Pædagogisk konsulent, rådgiver og terapeut.<br />Jeg hjælper med at styrke relationer og skabe trivsel gennem nærvær og faglighed.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-light mb-6 uppercase">Hurtige links</h3>
            <ul className="space-y-4">
              <li><Link to="/hvem-er-jeg" className="text-stone-200 hover:text-white transition-colors">Hvem er jeg</Link></li>
              <li><Link to="/oplaeg" className="text-stone-200 hover:text-white transition-colors">Pædagogiske oplæg</Link></li>
              <li><Link to="/theraplay" className="text-stone-200 hover:text-white transition-colors">Theraplay</Link></li>
              <li><Link to="/marte-meo" className="text-stone-200 hover:text-white transition-colors">Marte Meo</Link></li>
              <li><Link to="/kontakt" className="text-stone-200 hover:text-white transition-colors">Kontakt</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-light mb-6 uppercase">Kontakt information</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-stone-200">
                <MapPin className="w-5 h-5 text-white shrink-0 mt-0.5" />
                <span>Højskolevej 1, 6000 Kolding</span>
              </li>
              <li className="flex items-center gap-3 text-stone-200">
                <Phone className="w-5 h-5 text-white shrink-0" />
                <a href="tel:+4520487080" className="hover:text-white transition-colors">
                  +45 20 48 70 80
                </a>
              </li>
              <li className="flex items-center gap-3 text-stone-200">
                <Mail className="w-5 h-5 text-white shrink-0" />
                <a href="mailto:vejentilbarnet@gmail.com" className="hover:text-white transition-colors">
                  vejentilbarnet@gmail.com
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-xs text-stone-200">
                Bemærk: Ingen kunder fra Kolding Kommune, da jeg stadig er ansat i Kolding Kommune.
              </p>
            </div>
          </div>
        </div>
        
        <div className="pt-8 border-t border-white/10 text-center flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-stone-300 text-sm">
            &copy; {new Date().getFullYear()} Anette Lundager Schädler. Alle rettigheder forbeholdes.
          </p>
          <Link to="/privatlivspolitik" className="text-stone-300 hover:text-white text-sm transition-colors">
            Privatlivspolitik
          </Link>
        </div>
      </div>
    </footer>
  );
}
